'use strict';

function PerformanceReviewNavigationController(performanceReviewService, $route) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isCurrent = isCurrent;

  function $onInit() {
    vm.urls = {
      invite: performanceReviewService.urls.invite.base({ round: $route.current.params.round }),
      basis: performanceReviewService.urls.basis.base({ round: $route.current.params.round }),
      distribution: performanceReviewService.urls.distribution.base({ round: $route.current.params.round })
    };
  }

  function isCurrent(route) {
    return $route.current.regexp.test((route || ' ').charAt(0) === '#' ? route.substring(1) : route);
  }
}

module.exports = PerformanceReviewNavigationController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-navigation/performance-review-navigation.controller.js
 ** module id = 288
 ** module chunks = 0
 **/